<div class="edit-planning-container">

    <div class="title">
        <span>{{'planning.duplicateBeforeDay' | translate}}</span>
        <span class="active-day">{{'days.' + days[activeDayIndex].name | translate}} </span>
        <span>{{'planning.duplicateAfterDay' | translate}}</span>
    </div>
    <div class="edit-planning-main-container">
        <div class="column">
            <mat-checkbox color="primary" [checked]="allComplete" (change)="setAll($event.checked)">
                {{'days.allDays' | translate}}
            </mat-checkbox>
            <mat-checkbox color="primary" *ngFor="let day of days.slice(0, 3); let i = index;" [disabled]="day.disabled"
                [(ngModel)]="day.completed" (change)="handleEmit()">
                {{'days.'+day.name | translate}}
            </mat-checkbox>
        </div>

        <div class="column">
            <mat-checkbox color="primary" *ngFor="let day of days.slice(3); let i = index " [disabled]="day.disabled"
                [(ngModel)]="day.completed" (change)="handleEmit()">
                {{'days.'+day.name | translate}}
            </mat-checkbox>
        </div>
    </div>

</div>
